import React, {createContext} from "react";
const ParameterContext: React.Context<React. SetStateAction<any>> = createContext(null);
export default ParameterContext;
